<div class="sidebar" [ngClass]="{ 'expanded': isExpanded }">
    <div class="header">
      <h1 class="title">
        Excursion Tracking
      </h1>
      <!-- <div class="toggle" (click)="handleSidebarToggle()">
        <span class="chevron"></span>
      </div> -->
    </div>
    <div class="content">
      <div class="link">
        <div class="content"  [routerLinkActive]="'active'">
          <div class="icon">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
              <title>Stockholm-icons / Home / Flower2</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              
            </svg>
          </div>
          <div class="title"><a [routerLink]="['/dashboard']">Dashboard</a></div>
        </div>
      </div>
      <div class="link with-children">
        <div class="content" [routerLink]="['/configuration']" [routerLinkActive]="'active'">
          <div class="icon">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
              <title>Stockholm-icons / Home / Flower2</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              
            </svg>
          </div>
          <div class="title">Excursion</div>
        </div>
        
          <div class="link">
            <div class="content" [routerLink]="['/configuration']" [queryParams]="{ 'child': '1' }"
              [routerLinkActive]="'active'">
              <div class="icon">
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                  <title>Stockholm-icons / Home / Flower2</title>
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  
                </svg>
              </div>
              <div class="title">Transfer</div>
            </div>
          </div>
          <div class="link">
            <div class="content" [routerLink]="['/configuration']" [queryParams]="{ 'child': '2' }"
              [routerLinkActive]="'active'">
              <div class="icon">
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                  <title>Stockholm-icons / Home / Flower2</title>
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  
                </svg>
              </div>
              <div class="title">Airport service</div>
            </div>
          </div>
          <div class="link">
            <div class="content" [routerLink]="['/configuration']" [queryParams]="{ 'child': '3' }"
              [routerLinkActive]="'active'">
              <div class="icon">
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                  <title>Stockholm-icons / Home / Flower2</title>
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  
                </svg>
              </div>
              <div class="title">Daily Report</div>
            </div>
          </div>
        
      </div>
      <div class="link">
        <div class="content" [routerLink]="['/bookings']" [routerLinkActive]="'active'">
          <div class="icon">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
              <title>Stockholm-icons / Home / Flower2</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              
            </svg>
          </div>
          <div class="title">Setting</div>
        </div>
      </div>
    </div>
    <div class="footer"></div>
  </div>